import AccountsDashboard from '../../components/AccountsDashboard'

interface AccountsDashboardPageProps {
  tab?: string
}

const AccountsDashboardPage = ({ tab }: AccountsDashboardPageProps) => {
  return <AccountsDashboard initialTab={tab} />
}

export default AccountsDashboardPage
